module.exports = "fragment ParagraphFragment on Paragraph {\n  textFragments {\n    ...TextFragmentFragment\n  }\n  alignment\n}\n"